// import React, { useState } from "react";
// import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input } from "@nextui-org/react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// const PremiumPlanPopup = ({ isOpen, onClose, companyId }) => {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [address, setAddress] = useState("");
//   const [pincode, setPincode] = useState("");
//   const [phoneNumber, setPhoneNumber] = useState("");
  
//   const plans = [
//     {
//       id: "6month",
//       name: "6-Month Plan",
//       price: 1,
//       posts: "20 posts",
//       description: "Post up to 20 jobs in 6 months.",
//     },
//     {
//       id: "12month",
//       name: "12-Month Plan",
//       price: 949,
//       posts: "Unlimited posts",
//       description: "Post unlimited jobs for 12 months.",
//     },
//   ];

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => {
//         resolve(true);
//       };
//       script.onerror = () => {
//         resolve(false);
//       };
//       document.body.appendChild(script);
//     });
//   };

//   const handlePayment = async (plan) => {
//     // Validate form fields
//     if (!name || !address || !pincode || !phoneNumber) {
//       toast.error("All fields are required", {
//         position: "top-center",
//         autoClose: 1000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "colored",
//       });
//       return;
//     }

//     const res = await loadRazorpayScript();
//     if (!res) {
//       toast.error("Razorpay SDK failed to load. Are you online?");
//       return;
//     }

//     // Create order data
//     const orderData = {
//       name,
//       address,
//       pincode,
//       phoneNumber,
//       date: new Date().toLocaleString("en-US", {
//         month: "short",
//         day: "2-digit",
//         year: "numeric",
//       }),
//       planId: plan.id,
//       companyId,
//       amount: plan.price,
//     };

//     // In a real app, you would send this to your backend to create a Razorpay order
//     // For demo purposes, we'll create options directly
//     const options = {
//       key: "rzp_test_TvMb1SvsoF5EjR", // Replace with your Razorpay key
//       amount: plan.price * 100, // Amount in paise
//       currency: "INR",
//       name: "Job Portal Premium",
//       description: plan.description,
//       order_receipt: `order_rcpt_${plan.id}_${companyId}`,
//       handler: function (response) {
//         toast.success("Payment Successful");
//         console.log("Payment response:", response);
//         // Here you would typically verify the payment signature with your backend
//         // and then save the payment details to your database
//         const paymentInfo = {
//           ...orderData,
//           paymentId: response.razorpay_payment_id,
//           orderId: response.razorpay_order_id,
//           signature: response.razorpay_signature,
//         };
//         console.log("Payment info:", paymentInfo);
//         // Save to database or send to backend
//         // await savePaymentDetails(paymentInfo);
//         onClose();
//       },
//       prefill: {
//         name,
//         contact: phoneNumber,
//       },
//       notes: {
//         address,
//         pincode,
//         companyId,
//         plan: plan.name,
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     try {
//       const paymentObject = new window.Razorpay(options);
//       paymentObject.open();
//     } catch (error) {
//       console.error("Payment error:", error);
//       toast.error("Payment failed. Please try again.");
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside">
//       <ModalContent>
//         <ModalHeader className="flex flex-col gap-1">
//           Upgrade to Premium
//         </ModalHeader>
//         <ModalBody>
//           <p className="text-default-600">
//             You've reached the limit of 2 posts this month. Upgrade to a premium plan to post more jobs.
//           </p>
          
//           <div className="space-y-4 mt-4">
//             <Input
//               label="Full Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               required
//             />
//             <Input
//               label="Address"
//               value={address}
//               onChange={(e) => setAddress(e.target.value)}
//               required
//             />
//             <Input
//               label="Pincode"
//               value={pincode}
//               onChange={(e) => setPincode(e.target.value)}
//               required
//             />
//             <Input
//               label="Phone Number"
//               value={phoneNumber}
//               onChange={(e) => setPhoneNumber(e.target.value)}
//               required
//             />
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//             {plans.map((plan) => (
//               <div
//                 key={plan.id}
//                 className="p-4 border rounded-lg hover:shadow-md transition-shadow"
//               >
//                 <h3 className="text-lg font-bold">{plan.name}</h3>
//                 <p className="text-primary-500 text-2xl font-semibold">
//                   ₹{plan.price}
//                 </p>
//                 <p className="text-default-500">{plan.posts}</p>
//                 <p className="text-default-400 text-sm">{plan.description}</p>
//                 <Button
//                   color="primary"
//                   className="mt-4 w-full"
//                   onClick={() => handlePayment(plan)}
//                 >
//                   Choose Plan
//                 </Button>
//               </div>
//             ))}
//           </div>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="default" onClick={onClose}>
//             Close
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// };

// export default PremiumPlanPopup;

















import React, { useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addDoc, collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { generateInvoice } from "../../utils/invoiceGenerator";
import { useAuth } from "../../context/AuthContext";

const PremiumPlanPopup = ({ isOpen, onClose, companyId }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  
  const plans = [
    {
      id: "6month",
      name: "6-Month Plan",
      price: 1,
      posts: "20 posts",
      description: "Post up to 20 jobs in 6 months.",
      duration: 6, // months
    },
    {
      id: "12month",
      name: "12-Month Plan",
      price: 949,
      posts: "Unlimited posts",
      description: "Post unlimited jobs for 12 months.",
      duration: 12, // months
    },
  ];

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const savePaymentToFirestore = async (paymentInfo) => {
    try {
      const paymentsRef = collection(db, "payments");
      const docRef = await addDoc(paymentsRef, {
        ...paymentInfo,
        status: "pending_verification",
        createdAt: new Date(),
        companyId: user.uid,
        companyName: user.displayName || user.email,
      });
      
      return docRef.id;
    } catch (error) {
      console.error("Error saving payment to Firestore:", error);
      throw error;
    }
  };

  const updateCompanySubscription = async (paymentInfo) => {
    try {
      const now = new Date();
      const expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + paymentInfo.planDuration);
      
      const companyRef = doc(db, "companies", user.uid);
      await updateDoc(companyRef, {
        subscription: {
          planId: paymentInfo.planId,
          planName: paymentInfo.planName,
          startsAt: now,
          expiresAt: expiryDate,
          status: "active",
          paymentId: paymentInfo.paymentId,
          postsAllowed: paymentInfo.planId === "12month" ? "unlimited" : 20,
          postsUsed: 0,
        }
      });
    } catch (error) {
      console.error("Error updating company subscription:", error);
      throw error;
    }
  };

  const verifyPaymentWithBackend = async (paymentInfo) => {
    // In a real app, you would call your backend to verify the payment signature
    // For demo purposes, we'll simulate a successful verification
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          verified: true,
          message: "Payment verified successfully"
        });
      }, 1000);
    });
  };

  const handlePaymentSuccess = async (paymentInfo) => {
    try {
      setIsProcessing(true);
      
      // 1. Verify payment with backend
      const verification = await verifyPaymentWithBackend(paymentInfo);
      if (!verification.verified) {
        throw new Error("Payment verification failed");
      }
      
      // 2. Save payment details to Firestore
      const paymentDocId = await savePaymentToFirestore(paymentInfo);
      
      // 3. Update company subscription
      await updateCompanySubscription(paymentInfo);
      
      // 4. Generate and download invoice
      const invoiceData = {
        invoiceNumber: `INV-${Date.now()}`,
        date: new Date().toLocaleDateString(),
        companyName: name,
        companyAddress: address,
        pincode,
        phoneNumber,
        items: [{
          description: paymentInfo.planName,
          amount: paymentInfo.amount,
        }],
        total: paymentInfo.amount,
        paymentId: paymentInfo.paymentId,
        transactionId: paymentInfo.orderId,
      };
      
      generateInvoice(invoiceData, `invoice_${paymentDocId}.pdf`);
      
      // 5. Navigate to verification success page
      navigate(`/payment-verification?paymentId=${paymentInfo.paymentId}&status=success`);
      
      toast.success("Payment verified and subscription activated!");
    } catch (error) {
      console.error("Payment processing error:", error);
      toast.error(`Payment processing failed: ${error.message}`);
    } finally {
      setIsProcessing(false);
      onClose();
    }
  };

  const handlePayment = async (plan) => {
    // Validate form fields
    if (!name || !address || !pincode || !phoneNumber) {
      toast.error("All fields are required", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    const res = await loadRazorpayScript();
    if (!res) {
      toast.error("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // Create order data
    const orderData = {
      name,
      address,
      pincode,
      phoneNumber,
      date: new Date().toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      }),
      planId: plan.id,
      planName: plan.name,
      planDuration: plan.duration,
      companyId,
      amount: plan.price,
    };

    const options = {
      key: "rzp_test_TvMb1SvsoF5EjR", // Replace with your Razorpay key
      amount: plan.price * 100, // Amount in paise
      currency: "INR",
      name: "Job Portal Premium",
      description: plan.description,
      order_receipt: `order_rcpt_${plan.id}_${companyId}`,
      handler: async function (response) {
        try {
          const paymentInfo = {
            ...orderData,
            paymentId: response.razorpay_payment_id,
            orderId: response.razorpay_order_id,
            signature: response.razorpay_signature,
          };
          
          await handlePaymentSuccess(paymentInfo);
        } catch (error) {
          console.error("Payment processing error:", error);
          toast.error("Payment processing failed. Please contact support.");
        }
      },
      prefill: {
        name,
        contact: phoneNumber,
      },
      notes: {
        address,
        pincode,
        companyId,
        plan: plan.name,
      },
      theme: {
        color: "#3399cc",
      },
    };

    try {
      const paymentObject = new window.Razorpay(options);
      paymentObject.on("payment.failed", function (response) {
        toast.error(`Payment failed: ${response.error.description}`);
        console.error("Payment failed:", response.error);
      });
      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error);
      toast.error("Payment failed. Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          Upgrade to Premium
        </ModalHeader>
        <ModalBody>
          <p className="text-default-600">
            You've reached the limit of 2 posts this month. Upgrade to a premium plan to post more jobs.
          </p>
          
          <div className="space-y-4 mt-4">
            <Input
              label="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <Input
              label="Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
            <Input
              label="Pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              required
            />
            <Input
              label="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className="p-4 border rounded-lg hover:shadow-md transition-shadow"
              >
                <h3 className="text-lg font-bold">{plan.name}</h3>
                <p className="text-primary-500 text-2xl font-semibold">
                  ₹{plan.price}
                </p>
                <p className="text-default-500">{plan.posts}</p>
                <p className="text-default-400 text-sm">{plan.description}</p>
                <Button
                  color="primary"
                  className="mt-4 w-full"
                  onClick={() => handlePayment(plan)}
                  isLoading={isProcessing}
                >
                  Choose Plan
                </Button>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="default" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PremiumPlanPopup;